import { render, staticRenderFns } from "./EditorModal.vue?vue&type=template&id=c67e920a&scoped=true"
import script from "./EditorModal.vue?vue&type=script&lang=js"
export * from "./EditorModal.vue?vue&type=script&lang=js"
import style0 from "./EditorModal.vue?vue&type=style&index=0&id=c67e920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67e920a",
  null
  
)

export default component.exports